const Constants = {
  All: 'All',
  APP_NAME: 'CMD',
  SIDE_MENU_CLICK_DATA: 'Place your settings here',
  MASTER_DATA: 'Master Data',
  BRAND_LOGO: 'Brand Logo',
  CERTIFICATION_ENGINEER: 'Certification Engineer',
  NOTIFICATION_ICON: 'action_notification_default',
  NAME: 'Nagaraju',
  SUBNAME: 'Super Admin',
  USER_STANDARD_ICON: 'user_standard',
  SEARCH_ICON: 'action_search_stroke',
  ADD_NEW: 'Add New',
  BUDGET_RESPONSIBLE: 'Budget Responsible',
  CERTIFIED_BODY: 'Certified Body',
  CERTIFICATION_TYPE: 'Certification Type',
  COUNTRY: 'Country',
  CURRENCY: 'Currency',
  ACTION: 'Action',
  CREATE: 'Create',
  SELECT_PRODUCT: 'Select Product Type',
  ALL: 'All',
  PRODUCT: 'Product',
  STATUS: 'Status',
  DISABLE: 'Disable',
  CONFIGURATIONS: {
    Select_Reference_Channel: 'Select Reference Channel',
    Select: 'Select',
  },
  HEADER_TITLE: 'Matter Portal',
  LOGIN_DESCRIPTION: 'My Account. My personalized experience. Schneider is your one destination which provides 24/7 access to all the content, software, tools, and services to help manage your business',
  LOGIN: 'Login',
  LOGIN_SSO: 'Login with SSO',
  EMAIL: 'Email',
  FAQ: 'FAQ',
  PASSWORD: 'Password',
  FORGOT_PASSWORD: 'Forgot Password ?',
  REMEMBER_ME: 'Remember me',
  OR_CONTINUE_WITH: 'Or Continue with',
  NEW_SCHNEIDER: 'New to Schneider Electric ?',
  REGISTER: 'Register'
};
export default Constants;
